'use client';

import { useEffect } from 'react';
import type { EffectCallback } from 'react';

/**
 * A hook that runs an effect only once (at mount).
 */
export function useEffectOnce(effect: EffectCallback) {
    useEffect(effect, []);
}
